import {
  requiredEmailValidator,
  requiredPhoneNumberValidator,
  requiredCountryValidator,
  requiredOnlyDigtsNotAllowedValidator,
} from '../components/Forms/validators'

export const LocationForm = {
  model: 'Location',
  format: [
    {
      widths: 'equal',
      fields: {
        name: {
          required: true,
          type: 'text',
          validator: (input) => {
            return requiredOnlyDigtsNotAllowedValidator(input, 'name')
          },
        },
        location_truck_capabilities: {
          type: 'multiple dropdown',
          label: 'Trucking Capabilities',
        },
      },
    },
    {
      widths: 'equal',
      fields: {
        address_1: {
          required: true,
          type: 'text',
        },
        address_2: {
          type: 'text',
        },
      },
    },
    {
      widths: 'equal',
      fields: {
        country: {
          required: true,
          type: 'country',
          validator: (input) => {
            return requiredCountryValidator(input)
          },
        },
        state: {
          required: true,
          type: 'dropdown search',
          url: '/main/states/',
          require_params: true,
          related_params: {
            country: 'country',
          },
          title_fields: ['name'],
          description_fields: [''],
        },
        city: {
          required: true,
          type: 'text',
        },
        zip_code: {
          required: true,
          type: 'text',
        },
      },
    },
    {
      widths: 'equal',
      fields: {
        on_site_contact_name: {
          required: true,
          type: 'text',
          label: 'On-Site Contact Name',
          validator: (input) => {
            return requiredOnlyDigtsNotAllowedValidator(input, 'contact name')
          },
        },
        email: {
          required: true,
          type: 'text',
          validator: (input) => {
            return requiredEmailValidator(input)
          },
        },
        phone: {
          required: true,
          type: 'phone',
          validator: (input) => {
            return requiredPhoneNumberValidator(input)
          },
        },
      },
    },
    {
      widths: 'equal',
      fields: {
        type: {
          required: true,
          type: 'dropdown',
        },
        location_tax_id: {
          label: 'Location Tax ID Number',
          type: 'text',
        },
      },
    },
  ],
}
